import { createAction, props } from '@ngrx/store';
export const setShowBenchmarkOption = createAction('[Custom PDF Report Modal] Set Show Benchmark Option', props());
